import { Injectable, inject } from '@angular/core';
import { AuthState } from '../../states/auth.state';
import { UserEntity } from '../../../domain/entities/user.entity';

/**
 * Set User Use Case
 *
 * Sets the authenticated user in the auth state.
 * Used by login components and authentication flows.
 */
@Injectable({ providedIn: 'root' })
export class SetUserUseCase {
  private readonly _authState = inject(AuthState);

  /**
   * Execute the use case
   * @param user - The authenticated user entity
   */
  public execute(user: UserEntity): void {
    this._authState.setUser(user);
  }
}
